<template>
  <div class="base-checkbox">
    <input :id="id" v-model="model" :value="value" type="checkbox" class="base-checkbox__input" hidden />
    <label :for="id" class="base-checkbox__label">{{ label }}</label>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  interface Props {
    id: string;
    modelValue: boolean[] | string[] | object[];
    value: boolean | string | object;
    label: string;
  }

  const emits = defineEmits(['update:modelValue']);
  const props = defineProps<Props>();

  const model = computed({
    get() {
      return props.modelValue;
    },
    set(value) {
      emits('update:modelValue', value);
    },
  });

  // const toggleCheckbox = () => {
  //   isChecked.value = !isChecked.value;
  //   checkboxEmit('change', { checked: isChecked.value, label: props.label });
  // };
</script>

<style scoped lang="scss">
  @use '@/assets/scss/variables' as vars;

  .base-checkbox {
    display: flex;
    align-items: center;
    .base-checkbox__input:checked + .base-checkbox__label {
      &:before {
        background: var(--brand-primary);
        border-color: var(--brand-primary);
      }
      &:after {
        position: absolute;
        //top: 0.8209vw;
        left: 0.8955vw;
        content: '';
        width: 1.194vw;
        height: 0.7463vw;
        border-left: 0.2239vw solid #fff;
        border-bottom: 0.2239vw solid #fff;
        transform: rotate(-45deg);
        @media (max-width: vars.$md) {
          //top: 4px;
          left: 4px;
          width: 12px;
          height: 5px;
          border-width: 1px;
        }
      }
    }
    .base-checkbox__label {
      position: relative;
      display: flex;
      align-items: center;
      font-size: 1.9403vw;
      @media (max-width: vars.$md) {
        font-size: 16px;
      }
      @media (max-width: vars.$sm) {
        font-size: 20px;
      }
      &:before {
        flex-shrink: 0;
        display: block;
        content: '';
        width: 2.9851vw;
        height: 2.9851vw;
        border-radius: 0.2985vw;
        border: 0.2985vw solid var(--border-color-secondary);
        margin-right: 1.0448vw;
        @media (max-width: vars.$md) {
          width: 22px;
          height: 22px;
          border-radius: 4px;
          border-width: 2px;
          margin-right: 6px;
        }
      }
    }
  }
</style>
